(function () {
    'use strict';

    angular
        .module('app')
        .controller('ListHostsController', ListHostsController);

        ListHostsController.$inject = ['$state', 'dialog', '$scope', '$http'];

        function ListHostsController($state, dialog, $scope, $http) {
            var vm = this;
            vm.state = $state;
            vm.reactivateProfile = reactivateProfile;

            vm.superHostInfo = function SuperHostInfo(e) {
                e.preventDefault();
                e.stopPropagation();
                dialog.info('superhost-info');
            }
            vm.editHost = function (e, host) {
                e.preventDefault();
                e.stopPropagation();
                $state.go('edit_space', {space_slug: host.space_slug});
            }

            function reactivateProfile(e, host) {
                $http.patch('api/space/deactivated_status/' + host.space_slug + '/false/')
                    .then(function (response) {
                        host.space_deactivated_at = null;
                        $scope.$applyAsync();
                        dialog.info('profile-reactivated-info');
                    });
            }
        }
})();

